/* CR-04: policy navigation uses native /policies/* hrefs from Liquid (gds-menu-url).
   Keep only ?view=gds cleanup on canonical policy URLs. Obsolete /pages/* bookmarks
   are handled by Shopify Admin URL redirects (not client-side href rewriting). */
(function () {
  var CANON = {
    privacy: '/policies/privacy-policy',
    terms: '/policies/terms-of-service',
    shipping: '/policies/shipping-policy',
    refund: '/policies/refund-policy'
  };

  function normalizePath(pathname) {
    if (!pathname) return '';
    return pathname.replace(/\/+$/, '') || '/';
  }

  function policyCanonFromPath(path) {
    path = normalizePath(path);
    if (path === CANON.privacy) return CANON.privacy;
    if (path === CANON.terms) return CANON.terms;
    if (path === CANON.shipping) return CANON.shipping;
    if (path === CANON.refund) return CANON.refund;
    return null;
  }

  (function stripPolicyViewParam() {
    try {
      var path = normalizePath(window.location.pathname);
      if (!policyCanonFromPath(path)) return;
      var params = new URLSearchParams(window.location.search || '');
      if (params.get('view') !== 'gds') return;
      window.location.replace(path + (window.location.hash || ''));
    } catch (e) {}
  })();
})();

/* gds-cr03-homepage — clean root URL only (no redirects to ?page= / ?view=) */
(function () {
  try {
    var path = (window.location.pathname || '').replace(/\/+$/, '') || '/';
    if (path !== '/') return;
    var q = window.location.search || '';
    if (!q || !/[?&](page|view|_cr03|_fd|pb)=/.test(q)) return;
    // Do not clean if this HTML still contains the legacy forcer (let gds-cr03-home.js hop once).
    if (/params\.set\(\s*['"]page['"]\s*,\s*['"]109['"]\s*\)/.test(document.documentElement.innerHTML)) return;
    window.history.replaceState(null, '', '/' + (window.location.hash || ''));
  } catch (e) {}
})();

/* HI-01 — strip non-functional wishlist UI (incl. sticky CDN HTML shells) */
(function () {
  function stripWishlistUi(root) {
    var scope = root || document;
    var sel = [
      '#gds-wish-btn',
      '#gds-purchase-wish',
      '.btn-purchase-wish',
      '.pcard .wish',
      'button[aria-label="Add to wishlist"]',
      'a[aria-label="Add to wishlist"]'
    ].join(',');
    try {
      scope.querySelectorAll(sel).forEach(function (el) {
        el.remove();
      });
    } catch (e) {}

    try {
      scope.querySelectorAll('a.action-item, a').forEach(function (a) {
        var label = ((a.textContent || '') + ' ' + (a.getAttribute('aria-label') || '')).toLowerCase().replace(/\s+/g, ' ');
        if (label.indexOf('wishlist') === -1) return;
        var href = (a.getAttribute('href') || '').toLowerCase();
        var path = href.split('?')[0];
        // Remove header/nav wishlist that points at Search or has no real destination.
        if (!href || href === '#' || path === '/search' || path.indexOf('/search') === 0) {
          a.remove();
        }
      });
    } catch (e2) {}
  }

  function run() {
    stripWishlistUi(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* HI-04 — rewrite unsupported "verified buyers" claims in place on sticky PDP shells */
(function () {
  function replaceVerifiedBuyerClaims() {
    try {
      if (!/\/products\//.test(window.location.pathname || '')) return;
      document.querySelectorAll('.gds-jdgm-summary-note, [data-gds-jdgm-summary-note]').forEach(function (el) {
        if (!/verified buyers/i.test(el.textContent || '')) return;
        el.textContent = 'Be the first to share your experience.';
        el.classList.add('gds-jdgm-summary-note--empty');
      });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceVerifiedBuyerClaims);
  } else {
    replaceVerifiedBuyerClaims();
  }
})();

/* HI-03 — replace unsubstantiated Best Price Guarantee claims on sticky CDN shells */
(function () {
  function replaceBestPriceClaims(root) {
    var scope = root || document;
    try {
      scope.querySelectorAll('.footer-marquee .fm-item .txt strong, .footer-marquee strong').forEach(function (el) {
        if (!/best\s*price\s*guarantee/i.test(el.textContent || '')) return;
        el.textContent = 'Fair Everyday Pricing';
        var wrap = el.parentElement;
        if (!wrap) return;
        var sub = wrap.querySelector('span');
        if (sub && /our promise to you/i.test(sub.textContent || '')) {
          sub.textContent = 'Deals across every department';
        }
      });
    } catch (e) {}
  }

  function run() {
    replaceBestPriceClaims(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
// bust 1785849001-policy-canon

/* Client-approved public contact on legal pages — repair stale page_cache bodies */
(function () {
  var ADDR = '34 Glen Avenue, Winnipeg, Manitoba, Canada R2M 1V5';
  var NOTE = 'Weekend messages answered next business day.';

  function brokenAddressHtml(html) {
    return /<strong>\s*Address\s*<\/strong>\s*<br\s*\/?>\s*,\s*Winnipeg/i.test(html || '');
  }

  function fixDomText() {
    try {
      document.querySelectorAll('.policy-body p, .rte p').forEach(function (p) {
        var html = p.innerHTML || '';
        if (brokenAddressHtml(html) || (/Address/i.test(p.textContent || '') && /,\s*Winnipeg,\s*Manitoba,\s*Canada\s*$/i.test((p.textContent || '').replace(/\s+/g, ' ').trim()) && (p.textContent || '').indexOf('34 Glen') === -1)) {
          p.innerHTML = '<strong>Address</strong><br>' + ADDR;
        }
      });
    } catch (e) {}
  }

  function rehydrateLegalSection() {
    try {
      var section = document.querySelector('[id*="__gds_legal_ui"], [id*="__gds_legal"]');
      if (!section) {
        fixDomText();
        return;
      }
      var body = section.querySelector('.policy-body');
      if (!body || !brokenAddressHtml(body.innerHTML)) {
        fixDomText();
        return;
      }
      var id = section.id.replace(/^shopify-section-/, '');
      var url = window.location.pathname + '?sections=' + encodeURIComponent(id);
      fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data[id]) {
            fixDomText();
            return;
          }
          if ((data[id] || '').indexOf('34 Glen Avenue') === -1) {
            fixDomText();
            return;
          }
          section.outerHTML = data[id];
        })
        .catch(function () { fixDomText(); });
    } catch (e) {
      fixDomText();
    }
  }

  /* gds-ship-hi02: keep processing 1–2 / shipping 3–15 after dispatch on stale page_cache HTML */
  var HI02_DELIVERY =
    'Estimated shipping time is 3–15 business days after dispatch. Delivery times may vary depending on the product, supplier, destination, carrier, and other logistics factors.';
  var HI02_DELIVERY_STRONG =
    'Estimated shipping time is <strong>3–15 business days</strong> after dispatch. Delivery times may vary depending on the product, supplier, destination, carrier, and other logistics factors.';

  function rewriteShippingInPlace(root, html) {
    var next = html
      .replace(/Orders are typically processed within\s*<strong>\s*3[–-]15\s*business days\s*<\/strong>/gi, 'Orders are processed within <strong>1–2 business days</strong>')
      .replace(/Orders are typically processed within\s*<strong>\s*1[–-]2\s*business days\s*<\/strong>/gi, 'Orders are processed within <strong>1–2 business days</strong>')
      .replace(/Orders are processed within\s*<strong>\s*3[–-]15\s*business days\s*<\/strong>/gi, 'Orders are processed within <strong>1–2 business days</strong>')
      .replace(/processed within\s*<strong>\s*3[–-]15\s*business days\s*<\/strong>/gi, 'processed within <strong>1–2 business days</strong>')
      .replace(/processed within\s*3[–-]15\s*business days/gi, 'processed within 1–2 business days')
      .replace(/Most orders are delivered within\s*<strong>\s*3[–-]15\s*business days\s*<\/strong>, depending on the product, supplier, destination, and shipping method\./gi, HI02_DELIVERY_STRONG)
      .replace(/Most orders are delivered within\s*3[–-]15\s*business days, depending on the product, supplier, destination, and shipping method\./gi, HI02_DELIVERY)
      .replace(/ship(?:s)? within\s*1[–-]2\s*business days/gi, 'are processed within 1–2 business days. Estimated shipping time is 3–15 business days after dispatch');
    if (next !== html) root.innerHTML = next;
  }

  function shippingCopyIsStale(html) {
    return /Most orders are delivered within/i.test(html) ||
      /processed within[\s\S]{0,40}3[–-]15\s*business days/i.test(html) ||
      /typically processed within/i.test(html);
  }

  function normalizeShippingTimeline() {
    try {
      var path = (window.location.pathname || '').replace(/\/+$/, '') || '/';
      if (path !== '/policies/shipping-policy') return;
      var root = document.querySelector('.policy-body, .shopify-policy__body, .rte');
      if (!root) return;
      var html = root.innerHTML || '';
      if (!shippingCopyIsStale(html)) return;

      function applyFresh(data) {
        var fresh = (data && (data['gds-policy-layout'] || data['gds-policy-main'])) || '';
        if (fresh && /Orders are processed within/i.test(fresh) && /after dispatch/i.test(fresh)) {
          var host =
            document.getElementById('shopify-section-gds-policy-main') ||
            document.getElementById('shopify-section-gds-policy-layout') ||
            document.querySelector('.gds-policy') ||
            root.closest('.shopify-section');
          if (host) {
            host.outerHTML = fresh;
            return true;
          }
        }
        return false;
      }

      fetch(path + '?sections=gds-policy-layout,gds-policy-main', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!applyFresh(data)) rewriteShippingInPlace(root, html);
        })
        .catch(function () {
          rewriteShippingInPlace(root, html);
        });
    } catch (e) {}
  }

  function normalizeFaqShippingCopy() {
    try {
      var path = (window.location.pathname || '').replace(/\/+$/, '') || '/';
      if (path !== '/pages/faqs') return;
      var nodes = document.querySelectorAll('.gds-faq, .faq, .rte, [class*="faq"]');
      if (!nodes.length) nodes = [document.body];
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var html = el.innerHTML || '';
        if (!/Most orders are delivered within/i.test(html) && !/How long does shipping take/i.test(html)) continue;
        var next = html.replace(
          /Most orders are delivered within\s*3[–-]15\s*business days, depending on the product, supplier, destination, and shipping method\./gi,
          'Orders are processed within 1–2 business days. ' + HI02_DELIVERY
        );
        if (next !== html) el.innerHTML = next;
      }
    } catch (e) {}
  }

  function run() {
    rehydrateLegalSection();
    normalizeShippingTimeline();
    normalizeFaqShippingCopy();
    setTimeout(normalizeShippingTimeline, 600);
    setTimeout(normalizeFaqShippingCopy, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }


})();
